export const USERS_ACTIONS = {
  fetch: {
    request: "USERS/FETCH_REQUEST",
    success: "USERS/FETCH_SUCCESS",
    error: "USERS/FETCH_ERROR"
  },
  reset: "USERS/RESET"
};
